module.exports = __webpack_public_path__ + "img/stock6.fd00d92e.png";